import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * GoalsTracker — derives goals and mastery from actual interview data.
 * No hardcoded data; everything computed from props.
 */
const GoalsTracker = ({ goals, totalInterviews = 0, avgScore = 0 }) => {
    // Determine mastery level from real data
    const getMasteryLevel = () => {
        if (totalInterviews >= 20 && avgScore >= 85) return { label: 'Expert', level: 5 };
        if (totalInterviews >= 15 && avgScore >= 75) return { label: 'Advanced', level: 4 };
        if (totalInterviews >= 8 && avgScore >= 60) return { label: 'Intermediate', level: 3 };
        if (totalInterviews >= 3) return { label: 'Developing', level: 2 };
        if (totalInterviews >= 1) return { label: 'Beginner', level: 1 };
        return { label: 'Not Started', level: 0 };
    };

    const mastery = getMasteryLevel();

    const masteryColors = {
        0: 'text-slate-400',
        1: 'text-slate-600',
        2: 'text-blue-600',
        3: 'text-amber-600',
        4: 'text-emerald-600',
        5: 'text-emerald-500',
    };

    return (
        <div className="bg-white rounded-2xl border border-slate-100 p-6">
            <h3 className="text-[10px] font-black tracking-[0.2em] text-slate-400 mb-6 flex items-center gap-2">
                <Icon name="Target" size={12} className="text-emerald-500" /> Preparation Goals
            </h3>
            
            <div className="space-y-6">
                {goals.map((goal, idx) => (
                    <div key={idx} className="space-y-2">
                        <div className="flex items-center justify-between">
                            <span className="text-[12px] font-bold text-slate-700">{goal.title}</span>
                            <span className={`text-[11px] font-black ${goal.completed ? 'text-emerald-500' : 'text-slate-400'}`}>
                                {goal.completed ? 'Completed' : `${Math.round(goal.progress)}%`}
                            </span>
                        </div>
                        <div className="h-1.5 bg-slate-50 rounded-full overflow-hidden">
                            <div 
                                className={`h-full rounded-full transition-all duration-1000 ${
                                    goal.completed ? 'bg-emerald-500' : 'bg-slate-900'
                                }`}
                                style={{ width: `${Math.min(goal.progress, 100)}%` }}
                            />
                        </div>
                    </div>
                ))}
            </div>
            
            <div className="mt-8 pt-6 border-t border-slate-50">
                <div className="flex items-center justify-between text-[11px] font-black text-slate-400 tracking-widest">
                    <span>Mastery Level</span>
                    <span className={masteryColors[mastery.level]}>{mastery.label}</span>
                </div>
                <div className="mt-2 flex gap-1">
                    {[1, 2, 3, 4, 5].map(i => (
                        <div key={i} className={`h-1.5 flex-1 rounded-sm transition-all duration-500 ${i <= mastery.level ? 'bg-emerald-500' : 'bg-slate-100'}`} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default GoalsTracker;
